const Pin = {

    // FIELDS
    "tehsil": "Tehsil",
    "code": "Code",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "pin": "PIN",

    // ERROR
    "error_tehsil": "Select Tehsil",
    "error_status": "Select Status",
    "error_code": "Enter Code",
    "error_invalid_code": "Invalid Code",

    // TABLE HEADER
    "table_tehsil": 'TEHSIL',
    "table_status": 'STATUS',

}

export default Pin;